import { StepDto } from '@/modules/onboarding/status/domain/dtos';
import { SectionBase } from '@/modules/onboarding/status/domain/services/onboarding-step/step';

export default class Confirmation implements SectionBase {
  getStepAndSubStep(): StepDto {
    return {
      step: 8,
      substep: 1,
    };
  }
}
